import { SearchTerm } from "./SearchTerm";

const BioEventActionSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        translationKey: "name",
        searchOnName: "setting.trnName",
    },
    {
        heading: "Type",
        accessor: "type",
        searchOnName: "setting.settingType.trnName",
        translationKey: "type"
    },
    {
        heading: "Event Type",
        accessor: "eventType",
        searchOnName: 'eventType.trnName',
        translationKey: 'eventType'
    }
];

export default BioEventActionSearch;
